import React from 'react';

const ProgressContext = React.createContext(null);

export default ProgressContext;
